import './Popover.scss';
import clsx from 'clsx';
import React, { memo, PropsWithChildren, ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip as ReactTooltip, PlacesType } from 'react-tooltip';
import { RuntimeContext } from 'src/runtimeContext';

type Props = PropsWithChildren<{
  id: string;
  place: PlacesType;
  disabled?: boolean;
  opened?: boolean;
  value: ReactNode;
  className?: string;
  setOpened?: (opened: boolean) => void;
  onClose?: () => void;
}>;

export const Popover = memo(({
  id,
  place,
  disabled,
  opened,
  value,
  className,
  setOpened,
  onClose,
  children,
}: Props) => {
  const { modalRoot } = useContext(RuntimeContext);
  return (
    <div className="bp-popover">
      <div
        className={clsx({
          'bp-popover__target': true,
          'bp-popover__target--disabled': disabled,
        }, className)}
        data-tooltip-id={id}
      >
        {children}
      </div>

      {createPortal(
        <ReactTooltip
          id={id}
          isOpen={opened}
          setIsOpen={setOpened}
          clickable={true}
          place={place}
          hidden={disabled}
          className="bp-popover__content"
          openOnClick={true}
          offset={0}
          noArrow={true}
          openEvents={{
            click: true,
            dblclick: true,
            focus: false,
            mouseenter: false,
            mouseover: false,
            mousedown: false,
          }}
          closeEvents={{
            mouseout: false,
            mouseleave: false,
            blur: true,
          }}
          afterHide={onClose}
        >
          {value}
        </ReactTooltip>,
        modalRoot,
      )}
    </div>
  );
});
